<template>
		<div class="send_warp" v-cloak>
			<div class="content">
				<!-- 顶部卡片 -->
				<div class="content_top">
					<div class="content_top_felx">
						<div class="top_felx_left">
							<!-- 头像 -->
							<div class="left_avatar">
								<img src="../../assets/images/activity/1yuan365new/send/avatar.png" alt="" />
							</div>
							<!-- 有效日期 -->
							<div class="left_valid">
								<div>
									<img src="../../assets/images/activity/1yuan365new/send/365-icon.png" alt="" />
								</div>
								<div class="left_valid_text" v-show="renewInfo">有效期至{{expireTime}}</div>
							</div>
						</div>
						<div class="top_felx_right">
							<div class="right_but" @click="renewBuy()" >
								{{renewInfo?'立即续费':'限时抢购>'}}
								<!-- icon -->
								<!-- <div class="right_icon">¥{{renewInfo?'798.4':'998>'}}/年</div> -->
							</div>
						</div>
					</div>
				</div>
				<!-- 第一部分 -->
				<div class="first_section">
					<div class="first_section_bg">
						<!-- 标题 -->
						<div class="first_top_img">
							<img src="../../assets/images/activity/1yuan365new/send/first-top.png" alt="" class="top_img" />
						</div>
						<!-- 二级标题 -->
						<div class="first_title_text">
							<span>每月重点行情分析，股市行情早知道</span>
						</div>
						<!-- 列内容 -->
						<div class="first_list">
              <div class="first_list_text" style="font-size: 17px;">年报专题篇--财报妙用   业绩报告中的机会</div>
							<div class="first_list_but">
								<div id="jumpFirstThr" class="red_but" @click="jumpFirstHandler('jumpFirstThr')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list">
							<div class="first_list_text">资金分析篇--DDE资金  主力动向全局监控</div>
							<div class="first_list_but">
								<div id="jumpFirstTwo" class="red_but" @click="jumpFirstHandler('jumpFirstTwo')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list">
							<div class="first_list_text">资金分析篇--北向资金  北向掘金思路</div>
							<div class="first_list_but">
								<div id="jumpFirstOne" class="red_but" @click="jumpFirstHandler('jumpFirstOne')">立即学习</div>
								<!-- <div class="yellow_but" >已学习</div> -->
							</div>
						</div>
						<!-- <div class="first_list">
							<div class="first_list_text">财报妙用--跟着大股东有肉吃</div>
							<div class="first_list_but">
								<div id="jumpFirstFro" class="red_but" @click="jumpFirstHandler('jumpFirstFro')">立即学习</div>
								<div class="yellow_but">已学习</div>
							</div>
						</div> -->
						<!-- 二级标题 -->
						<!-- <div class="first_title_text">
							<span>年卡专享</span>
						</div> -->
						<!-- <div class="first_list margin_bottom20">
							<div class="first_list_text">定期复盘收益长红</div>
							<div class="first_list_but">
								<div id="jumpFirstFiv" class="red_but" @click="jumpFirstHandler('jumpFirstFiv')">立即学习</div> -->
								<!-- <div class="yellow_but">已学习</div> -->
							<!-- </div>
						</div> -->
					</div>
				</div>
				<!-- 第二部分 -->
				<div class="first_section">
					<div class="first_section_bg">
						<!-- 标题 -->
						<div class="first_top_img">
							<img src="../../assets/images/activity/1yuan365new/send/second-top.png" alt="" class="top_img" />
						</div>
						<!-- 列内容 -->
						<div class="first_list">
							<div class="first_list_text">
								逐笔成交
								<span class="first_list_text_subset">成交明细一览无余</span>
							</div>
							<div class="first_list_but">
								<div id="1" class="red_but" @click="jumpSecondHandler('1')">立即学习</div>
								<!-- <div id="1" class="yellow_but" @click="jumpSecondHandler('1')">已学习</div> -->
							</div>
						</div>
						<div class="first_list">
							<div class="first_list_text">
								全息盘口
								<span class="first_list_text_subset">主力大单尽收眼底</span>
							</div>
							<div class="first_list_but">
								<div id="2" class="red_but" @click="jumpSecondHandler('2')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list">
							<div class="first_list_text">
								紧跟波段
								<span class="first_list_text_subset">底部介入、顶部避险</span>
							</div>
							<div class="first_list_but">
								<div id="3" class="red_but" @click="jumpSecondHandler('3')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list">
							<div class="first_list_text">
								龙虎看盘
								<span class="first_list_text_subset">逐笔买卖比例</span>
							</div>
							<div class="first_list_but">
								<div id="4" class="red_but" @click="jumpSecondHandler('4')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list margin_bottom20">
							<div class="first_list_text">
								热钱追踪
								<span class="first_list_text_subset">跟随主力步伐，DDX天数越高越好</span>
							</div>
							<div class="first_list_but">
								<div id="5" class="red_but" @click="jumpSecondHandler('5')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
						<div class="first_list margin_bottom20">
							<div class="first_list_text">
								复盘神器
								<span class="first_list_text_subset">揭秘涨停原因，复盘庄家做法</span>
							</div>
							<div class="first_list_but">
								<div id="6" class="red_but" @click="jumpSecondHandler('6')">立即学习</div>
								<!-- <div class="yellow_but">已学习</div> -->
							</div>
						</div>
					</div>
				</div>
				<!-- 第三部分 -->
				<div class="third_section">
					<img src="../../assets/images/activity/1yuan365new/send/third-top.png" alt="" @click="jumpSecondHandler('7')">
				</div>
			</div>
      <div class="dialog" v-show="dialogSwitch" @click="closeDialog()" >
				<!-- 弹窗内容 -->
				<div class="dialog_content" @click.stop="openDialog()" >
					<p>您还不是付费会员</p>
					<p>请购买后再来查看哦~</p>
					<div class="dialog_but" @click.stop="closeDialog()">好的</div>
				</div>
			</div>
		</div>
</template>

<script>
import { th } from 'date-fns/locale';

export default {
  data() {
    return {
      token: this.$route.query.token,
      productId: this.$route.query.productId,
      month: this.$route.query.month,
      expireTime: "",
      renewInfo: false,
      dialogSwitch: false
    };
  },
  created() {
    debugger
    if (this.token) {
      var params = {
        token: this.token,
        productId: this.productId,
        month: this.month
      };
      this.$get("/client/estimatedEnd", params)
      .then(response => {
        if (response.code === 0) {
          if(response.data){
            if(response.data.renewInfo){
              this.renewInfo =  response.data.renewInfo;
              this.expireTime = response.data.expireTime;
            }
            if(response.data.hadViewColumns && response.data.hadViewColumns.length > 0){
              response.data.hadViewColumns.forEach(element => {
              this.changeViewButton(element)
              });
            }
          }

        }else{
          console.log(response.msg)
        }
      });
    } else {
      this.$router.push('/404')
    }
  },
  methods: {
    jumpFirstHandler(val) {
      if(this.renewInfo){
        var cname = document.getElementById(val).className;
        if(cname !== 'yellow_but'){
          this.hadView(val)
        }
        if(val == 'jumpFirstOne'){
          window.external.addcommand("BROWSEDLG?URL='http://1257862591.vod2.myqcloud.com/da59f6b0vodcq1257862591/fe25726f3270835014230431372/h08L4r2z90YA.mp4#DZHPOPUP(800,600)#'&TYPE=6")
          // window.open("http://ke.dzh.com.cn/search?q=北向资金")
        }else if(val == 'jumpFirstTwo'){
          window.external.addcommand("BROWSEDLG?URL='http://1257862591.vod2.myqcloud.com/da59f6b0vodcq1257862591/772b25923270835014228303244/AQcs0eD9ZuEA.mp4#DZHPOPUP(800,600)#'&TYPE=6")
          // window.open("http://ke.dzh.com.cn/search?q=主力资金")
        }else if(val == 'jumpFirstThr'){
          window.external.addcommand("BROWSEDLG?URL='http://1257862591.vod2.myqcloud.com/da59f6b0vodcq1257862591/f9a2070f3270835014230256133/fuaA8qZjbfsA.mp4#DZHPOPUP(800,600)#'&TYPE=6")
          // window.open('http://ke.dzh.com.cn/search?q=财报妙用')
        }else{
          window.open("http://ke.dzh.com.cn/search?q=AI%E8%B5%84%E9%87%91")
        }
      } else{
        this.openDialog();
      }
      
    },
    jumpSecondHandler(val) {
      if(val !== '7'){
        this.hadView(val)
      }
      if(val == '1'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=1177")
      }else if(val == '2'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=10026")
      }else if(val == '3'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=11424")
      }else if(val == '4'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=10101")
      }else if(val == '5'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=11431")
      }else if(val == '6'){
        window.open("http://help123.dzh.com.cn/help123/index.php?_url=/index/single&post_id=4030")
      }else if(val == '7'){
        window.open("https://ke.dzh.com.cn/")
      }
    },
    hadView(val){
      this.changeViewButton(val)
      var params = {
        columnId: val,
        token: this.token
      };
        this.$get("/client/hadView", params).then(response => {
        if (response.code !== 0) {
          console.log(response.msg)
        }
      });
    },
    renewBuy(){
      let origin = window.location.origin;
      let renewBuyUrl = origin + '/pay-mall/gateway?method=order.confirm.116.12&token=' + this.token + '&s=' + 'wisdomLecture'
      window.open(renewBuyUrl)
    },
    changeViewButton(val){
      var element = document.getElementById(val);
      if(element){
        document.getElementById(val).className = 'yellow_but'
        document.getElementById(val).textContent = '已学习'
      }
    },
    // 关闭弹窗
    closeDialog(){
			var that = this;
			that.dialogSwitch = false;
		},
    // 事件穿透
    openDialog:function(){
			var that = this;
			that.dialogSwitch = true;
		}
  }
}
</script>
<style>
body {
  /* min-width: auto !important; */
}
</style>

<style lang="css" scoped>
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
em,
strong,
th,
td,
textarea,
button,
input,
select,
figure,
figcaption {
  padding: 0;
  margin: 0;
  font-style: normal;
  font-weight: normal;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

body {
  font-family: PingFangSC-Regular, Helvetica, Tahoma, Arial, 'Microsoft YaHei', 'Hiragino Sans GB', 'WenQuanYi Micro Hei', sans-serif;
}

textarea,
button,
input,
select {
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  border: 0;
}

li,
dd {
  list-style: none;
}

a {
  text-decoration: none;
}

table {
  border-collapse: collapse;
}

img {
  border: 0;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: ' ';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

[v-cloak] {
  display: none !important;
}

.font-red {
  color: #ef3939 !important;
}

.font-green {
  color: #1eac4e !important;
}

/* PC */
html,
body {
  height: 100%;
  background: #fff;
}

/* app */
.send_warp {
  width: 580px;
  height: 100vh;
  overflow: hidden;
  min-width: 580px;
}

.send_warp .content {
  /* width: 580px; */
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin: 0 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.send_warp .content .content_top {
  height: 158px;
  width: 100%;
  background: url(../../assets/images/activity/1yuan365new/send/title.png);
  background-size: 100% 100%;
}

.send_warp .content .content_top .content_top_felx {
  width: 100%;
  height: 158px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
}

.send_warp .content .content_top .content_top_felx .top_felx_left {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}

.send_warp .content .content_top .content_top_felx .top_felx_left .left_avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
}

.send_warp .content .content_top .content_top_felx .top_felx_left .left_avatar img {
  width: 60px;
  height: 60px;
}

.send_warp .content .content_top .content_top_felx .top_felx_left .left_valid img {
  height: 30px;
  width: 178px;
}

.send_warp .content .content_top .content_top_felx .top_felx_left .left_valid .left_valid_text {
  font-size: 14px;
  color: #a7785f;
}

.send_warp .content .content_top .content_top_felx .top_felx_right .right_but {
  padding: 16px 30px;
  border-radius: 30px;
  background-image: linear-gradient(to right, #f0ad5f, #e49c4b, #d3812b);
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  position: relative;
}

.send_warp .content .content_top .content_top_felx .top_felx_right .right_icon {
  width: 84px;
  height: 24px;
  position: absolute;
  top: -14px;
  left: 0;
  background-image: url("../../assets/images/activity/1yuan365new/send/but-icon.png");
  background-size: 100% 100%;
  font-size: 14px;
  text-align: center;
  line-height: 22px;
  font-weight: bold;
}

.send_warp .content .first_section {
  margin: 0 auto;
  margin-top: 52px;
  width: 90%;
  background-color: #ffefc5;
  padding: 10px;
  border-radius: 8px;
}

.send_warp .content .first_section .first_section_bg {
  background-color: #fff;
  border-radius: 8px;
  display: inline-block;
  width: 100%;
  height: auto;
  padding: 0 20px;
}

.send_warp .content .first_section .first_section_bg .first_top_img {
  width: 100%;
  height: 50px;
  text-align: center;
  margin-top: -26px;
}

.send_warp .content .first_section .first_section_bg .first_top_img .top_img {
  height: 50px;
}

.send_warp .content .first_section .first_section_bg .first_title_text {
  text-align: center;
  margin-top: 20px;
  color: #d52f21;
}

.send_warp .content .first_section .first_section_bg .first_title_text span {
  font-weight: bold;
  font-size: 24px;
}

.send_warp .content .first_section .first_section_bg .margin_bottom20 {
  margin-bottom: 20px;
}

.send_warp .content .first_section .first_section_bg .first_list {
  margin-top: 17px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  background-color: #fdf3e9;
  border: 1px solid #f6eadc;
  border-radius: 8px;
  padding: 10px;
}

.send_warp .content .first_section .first_section_bg .first_list .first_list_text {
  color: #4d1d00;
  font-size: 16px;
  font-weight: bold;
}

.send_warp .content .first_section .first_section_bg .first_list .first_list_text .first_list_text_subset {
  font-size: 14px;
  color: #8f8c8a;
  margin-left: 15px;
}

.send_warp .content .first_section .first_section_bg .first_list .first_list_but .red_but {
  width: 113px;
  padding: 8px 0;
  background-image: linear-gradient(to top, #cd2f2f, #fc3737);
  border-radius: 30px;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.send_warp .content .first_section .first_section_bg .first_list .first_list_but .yellow_but {
  width: 113px;
  padding: 8px 0;
  background-color: #ffe7a6;
  border: 1px solid #fec1a4;
  border-radius: 30px;
  font-size: 14px;
  color: #d4832d;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.send_warp .content .third_section {
  width: 90%;
  margin: 25px auto;
  height: 104px;
}

.send_warp .content .third_section img {
  width: 100%;
  height: 100%;
}

.send_warp .content::-webkit-scrollbar-track-piece {
  background-color: #ffffff;
}

.send_warp .content::-webkit-scrollbar {
  width: 2px;
  height: 13px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.send_warp .content::-webkit-scrollbar-thumb {
  background-color: #b6b6b6;
  background-clip: padding-box;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  min-height: 28px;
}

.send_warp .content::-webkit-scrollbar-thumb:hover {
  background-color: #b6b6b6;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.send_warp .dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
  /* display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center; */
}

.send_warp .dialog .dialog_content {
  width: 340px;
  height: 202px;
  padding: 40px 56px;
  border-radius: 20px;
  background-color: #fff;
  text-align: center;
  position: sticky;
			top: 150px;
			left: 100px;
}

.send_warp .dialog .dialog_content p {
  font-size: 20px;
  margin-bottom: 5px;
}

.send_warp .dialog .dialog_content .dialog_but {
  width: 114px;
  height: 46px;
  border-radius: 20px;
  background-image: linear-gradient(to top, #3b44fb, #6372fd);
  margin: 0px auto;
  margin-top: 15px;
  font-size: 16px;
  color: #fff;
  line-height: 46px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/client/WisdomLecture.vue